import { observer } from 'mobx-react-lite'
import {
  DocumentRequestContent,
  DocumentRequestDialog,
} from '@/features/jobs/details/components/DocumentRequestDialog'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'
import { type DocumentRequestDialogViewModel } from './DocumentRequestDialogViewModel'

export interface DocumentRequestDialogContainerProps {
  vm: DocumentRequestDialogViewModel
}

export const DocumentRequestDialogContainer = observer(
  function DocumentRequestDialogContainer({
    vm,
  }: DocumentRequestDialogContainerProps) {
    return (
      <DocumentRequestDialog
        showing={vm.modal.showing}
        isSubmitPending={vm.submit.pending}
        onClose={vm.close}
        onSubmit={vm.submit}
      >
        {vm.fetch.match({
          pending: () => <ContentLoading size="compact" />,
          rejected: (err) => <ContentError error={err} />,
          resolved: () => (
            <DocumentRequestContent
              items={vm.requestableDocumentTypes.map((t) => ({
                id: t.id,
                name: t.name,
                checked: vm.selectedDocumentTypes.includes(t),
                onToggle: () => vm.toggle(t),
              }))}
            />
          ),
        })}
      </DocumentRequestDialog>
    )
  },
)
